import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';

export const dialogTitleStyles: SxProps<Theme> = { fontWeight: 700, pb: 0.5 };

export const subtitleStyles: SxProps<Theme> = { color: 'text.secondary', mb: 2 };

export const dialogActionsStyles: SxProps<Theme> = {
    px: 3,
    pb: 3,
    pt: 1,
    // The invite action sits opposite Close rather than beside it: it is the reason to
    // open this dialog, not a variant of dismissing it.
    justifyContent: 'space-between',
};

/**
 * Revoked and lapsed rows are dimmed rather than hidden -- the listing exists precisely
 * so the owner can see them.
 */
export const memberRowStyles = (isActive: boolean): SxProps<Theme> => ({
    opacity: isActive ? 1 : 0.6,
});
